import loadable from "@loadable/component";
import { useNavigate, useSearchParams } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { toast } from "react-toastify";
import { useState } from "react";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import { queryClient } from "../../router";
import CreateIcon from "../../Icons/CreateIcon";
import useTenantGetHook from "../../customHooks/useTenantControlGetHook";

const DraftOrderListComponent = loadable(
  () => import("../../components/Consignment/DraftOrderList")
);
const DraftOrderList = () => {
  const [searchParams, setSearchParms] = useSearchParams();
  const selectedOrder = searchParams.get("draft_selectedItems")?.split(",");
  const [openDeletePopup, setDeletePopup] = useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["pickup-request"],
    navigateURL: "/",
  });
  const { mutateAsync: removeitems, isPostLoading: isRemoving } = usePostHook({
    queryKey: ["pickup-request-items"],
    navigateURL: "",
  });

  const handleRemove = async (id: string) => {
    try {
      const url = `${APIS.PICKUPREQUEST}remove-draft-order/`;
      const res = await removeitems({
        url,
        formData: {
          order_ids: [id],
        },
      });
      if (res.status == 200) {
        queryClient.refetchQueries();
        setDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreate = async (setError: any) => {
    if (!selectedOrder) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.PICKUPREQUEST}`;
    let formData = {
      orders: selectedOrder,
      type: "pickup-request",
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const { data, isLoading: isPermissionListLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data && data?.custom_permissions;
  return (
    <div>
      <DraftOrderListComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        isRemoving={isRemoving}
        handleRemove={handleRemove}
        openDeletePopup={openDeletePopup}
        setDeletePopup={setDeletePopup}
        userPermissions={permissionsLists}
      />
    </div>
  );
};

export default DraftOrderList;

